import { format } from 'date-fns';

const serverDateFormat = 'yyyy-MM-dd';
const serverDatetimeFormat = "yyyy-MM-dd'T'HH:mm:ss.000";

export const convertToServerDate = (value: Date): string => format(value, serverDateFormat);
export const convertToServerDatetime = (value: Date): string => format(value, serverDatetimeFormat);
